import React from 'react'

import UserSelect from 'components/UserSelect'

import Editor from '../Editor'
import Card from '../Card'

import EmailCaptureSliderPreview from './EmailCaptureSliderPreview'
import UnsubmittedEmailCapturePlaybookPreview from 'components/shared/PlaybookPreviews/EmailCapture/UnsubmittedPreview'
import SubmittedEmailCapturePlaybookPreview from 'components/shared/PlaybookPreviews/EmailCapture/SubmittedPreview'

import './style.styl'

const EmailCaptureMessage = ({
  message,
  onMessageChange,
  headline,
  onHeadlineChange,
  thankYouMessage,
  onThankYouMessageChange,
  thankYouHeadline,
  onThankYouHeadlineChange,
  selectedUser,
  onAuthorChange,
  selectedFont
}) =>
  <div className="playbook-message playbook-email-capture-message">
    <header className="playbook-title-header">
      <h2>Customize the message your users will see.</h2>
      <p>What do you want to say? Keep it short and sweet, be personal and human!</p>
    </header>
    
    <Card
      title="Sign Up Message"
      description={headline}
      className="drift-form"
    >
      <div className="playbook-email-capture-message-preview">
        <UnsubmittedEmailCapturePlaybookPreview
          title={headline}
          message={message}
          previewUser={selectedUser}
          fontFamily={selectedFont}/>
      </div>
      <div className="playbook-edit-message-heading">Sign Up Headline</div>
      <input type="text" onChange={onHeadlineChange} value={headline} />
      <div className="playbook-edit-message-heading">Sign Up Message</div>
      <Editor value={message} onChange={onMessageChange} />
      <div className="playbook-edit-message-heading">Send From</div>
      <UserSelect selectedUserId={selectedUser ? selectedUser.id : null} onUserIdChange={onAuthorChange} />
    </Card>
    <Card
      title="Thank You Message"
      description={thankYouHeadline}
      className="drift-form"
    >
      <div className="playbook-email-capture-message-preview">
        <SubmittedEmailCapturePlaybookPreview title={thankYouHeadline} message={thankYouMessage} fontFamily={selectedFont}/>
      </div>
      <div className="playbook-edit-message-heading">Thank You Headline</div>
      <input type="text" onChange={onThankYouHeadlineChange} value={thankYouHeadline} />
      <div className="playbook-edit-message-heading">Thank You Message</div>
      <Editor onChange={onThankYouMessageChange} value={thankYouMessage} />
    </Card>
  </div>

export default EmailCaptureMessage



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailCaptureMessage/component.js